import { render, staticRenderFns } from "./ProductListFilters.vue?vue&type=template&id=dee0509e&"
import script from "./ProductListFilters.vue?vue&type=script&lang=ts&"
export * from "./ProductListFilters.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports